{
  "TASK": {
    "GENERAL": {
      "GET_ALL_TASK_TYPES": "Beim Lesen aller Aufgabearten ist ein Fehler aufgetreten.",
      "GET_ALL_TASKS": "Beim Lesen aller Aufgaben ist ein Fehler aufgetreten.",
      "GET_TASK": "Beim Lesen der Aufgabe ist ein Fehler aufgetreten.",
      "GET_TASK_OF_WORKFLOW": "Beim Lesen der Aufabe des Workflows ist ein Fehler aufgetreten.",
      "UPDATE_TASK": "Beim \u00C4ndern der Aufgabe ist ein Fehler aufgetreten.",
      "GET_CHECKPOINT": "Beim Lesen des Checkpunkts ist ein Fehler aufgetreten.",
      "CREATE_CHECKPOINT": "Beim Erstellen des Checkpunkts ist ein Fehler aufgetreten.",
      "UPDATE_CHECKPOINT": "Beim \u00C4ndern des Checkpunkts ist ein Fehler aufgetreten.",
      "DELETE_CHECKPOINT": "Beim L\u00F6schen des Checkpunkts ist ein Fehler aufgetreten.",
      "GET_DOCUMENTS": "Beim Lesen der Dokumente ist ein Fehler aufgetreten.",
      "ADD_DOCUMENT": "Beim Erstellen des Dokuments ist ein Fehler aufgetreten.",
      "DELETE_DOCUMENT": "Beim L\u00F6schen des Dokuments ist ein Fehler aufgetreten."
    },
    "TASK_NOT_FOUND": "Die Aufgabe konnte nicht gefunden werden.",
    "CHECKPOINT_NOT_FOUND": "Der Checkpunkt konnte nicht gefunden werden.",
    "NOT_ASSIGNED_TO_TASK": "Sie sind dieser Aufgabe nicht zugeteilt.",
    "STATE": {
      "OPEN": "Offen"
    }
  },
  "WORKFLOW": {
    "GENERAL": {
      "GET_WORKFLOW_TYPES": "Beim Lesen der Workflow Arten ist ein Fehler aufgetreten.",
      "GET_WORKFLOW_FILTERS": "Beim Lesen der Workflow Filter ist ein Fehler aufgetreten.",
      "GET_WORKFLOWS": "Beim Lesen der Workflows ist ein Fehler aufgetreten.",
      "GET_WORKFLOW": "Beim Lesen des Workflows ist ein Fehler aufgetreten.",
      "NEXT_TASK": "Beim Weiterschalten zur n\u00E4chsten Aufgabe ist ein Fehler aufgetreten.",
      "ADD_PARTICIPANTS": "Beim hinzuf\u00FCgen der Teilnehmer ist ein Fehler aufgetreten.",
      "GET_COMMENTS": "Beim Lesen der Kommentare ist ein Fehler aufgetreten.",
      "ADD_COMMENT": "Beim hinzuf\u00FCgen des Kommentars ist ein Fehler aufgetreten.",
      "UPDATE_COMMENT": "Beim \u00C4ndern des Kommentars ist ein Fehler aufgetreten.",
      "DELETE_COMMENT": "Beim l\u00F6schen des Kommentars ist ein Fehler aufgetreten.",
      "GET_HISTORY": "Beim Lesen der Historie ist ein Fehler aufgetreten."
    },
    "TASK_NOT_POSSIBLE_OUTCOME": "Es kann nicht zur gew\u00E4hlten Aufgabe weitergeschaltet werden, da sie kein m\u00F6glicher n\u00E4chster Schritt ist.",
    "STATE": {
      "ACTIVE": "Aktiv"
    },
    "TYPE": {
      "TASK": "Aufgabe",
      "STOCKPOSTING": "Einseitige Lagerbuchung"
    },
    "ROLE": {
      "role-initiator": "Ersteller",
      "role-erfassung": "Erfasser",
      "role-erfassen": "Erfasser",
      "role-bestaetigen": "Bestätiger",
      "role-erledigen": "Erlediger",
      "role-bearbeiten": "Bearbeiter",
      "role-freigabe": "Freigabe",
      "role-bestaetigung": "Bestätiger",
      "role-freigabeGF": "Freigabe Geschäftsführung",
      "role-buchhaltung": "Buchhaltung"
    }
  }
}
